module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-192x192-94d10bc50b2a16321ed44dfe351c164e.png";